import { Component, OnInit } from '@angular/core';
import { TutorService } from 'src/app/services/tutor.service';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-tutor',
  templateUrl: './tutor.component.html',
  styleUrls: ['./tutor.component.scss']
})
export class TutorComponent implements OnInit {
  public tutor:any={};
  public tutorLoaded:boolean=false;
  public tutorId;
  public tutorImage:string='';
  public newImageB64:string='';
  public newFileType:string='';
  public environment=environment;

  constructor(
    private _tutor: TutorService,
    private _notify: MatSnackBar,
    private _route: ActivatedRoute
  ) {
    this.tutorId=this._route.snapshot.paramMap.get('tutorId');
  }

  public notify(message:string, action:string) {
    this._notify.open(message, action, {
      duration: 4000,
      verticalPosition: 'top'
    });
  }

  public newAvatar(evt){
    var files = evt.target.files;
    var file = files[0];
    if (files && file) {
      if (!file.type.includes('image')) {
        this.notify('Only images can be uploaded.', 'OK');
      }
      this.newFileType=file.type;
      var reader = new FileReader();
      reader.onload =this._handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
    } else {
      this.newImageB64='';
      this.newFileType='';
      this.tutorImage = this.tutor.image;
    }
  }

  private _handleReaderLoaded(readerEvt) {
   var binaryString = readerEvt.target.result;
    this.newImageB64= btoa(binaryString);
    this.tutorImage='data:' + this.newFileType + ';base64, ' + this.newImageB64;
  }

  public resetImage(){
    this.tutorImage=this.tutor.image;
  }

  public updateTutor(){
    if (this.tutor.name == '') return this.notify('Tutor name can not be blank.', 'OK');
    this._tutor.updateTutor(this.tutor, this.newImageB64, this.newFileType).subscribe(
      (res:any) => {
        // console.log(res);
        this.notify('Tutor updated.', 'OK');
      }
    );
  }

  ngOnInit() {
    this._tutor.getTutor(this.tutorId).subscribe(
      data => {
        this.tutor=data;
        this.tutor.image=this.tutorImage=environment.apiEndpoint+'/storage/tutors/'+data.image;
        this.tutorLoaded=true;
      }
    );
  }

}
